var React = require('react');

function Comment (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","opacity":".71"},React.createElement("g",{"stroke":"#FFF","strokeLinecap":"square","strokeWidth":"2"},[React.createElement("path",{"d":"M13.568 25a12.463 12.463 0 0 0 6.932 2c1.156 0 2.308-.15 3.426-.444L28 29v-4.406A7.145 7.145 0 0 0 31 19a6.333 6.333 0 0 0-.766-3","key":0}),React.createElement("path",{"d":"M14.5 1C7.044 1 1 5.7 1 11.5a9.149 9.149 0 0 0 3 6.593V25l6.813-3.407c1.21.27 2.447.406 3.687.407C21.956 22 28 17.3 28 11.5S21.956 1 14.5 1z","key":1})])));
}

Comment.defaultProps = {"width":"32","height":"31","viewBox":"0 0 32 31"};

module.exports = Comment;

Comment.default = Comment;
